import * as React from 'react';
import { TiptapButton } from '../TiptapButton';
import { Editor } from '@tiptap/react';
import Lift from 'Shared/icons/lift.svg';

export const UnindentButton = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().liftListItem('listItem').run()}
         isDisabled={!editor.can().liftListItem('listItem')}
         icon={<Lift />}
         title={_js('Decrease indent')}
         overrideShortcut={'shift+tab'}
      />
   );
};
